import React from 'react';
import { ArrowUp, ArrowDown } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/utils';

interface MetricCardProps {
  id: number;
  title: string;
  value: string;
  change: string;
  trend: 'up' | 'down';
  image: React.ElementType | string;
}
function MetricCard({ id, title, value, change, trend, image }: MetricCardProps) {
  const isPath = typeof Image === 'string';

  return (
    <Card
      className={cn(
        'relative overflow-hidden border-none rounded-2xl bg-white text-slate-900 shadow-sm transition-all duration-500 cursor-pointer  hover:-translate-y-2 hover:shadow-2xl',
        id === 1 && 'bg-[#4B0082] text-white group'
      )}
    >
      <CardContent className="p-6 h-full flex flex-col justify-center relative border-[1px] border-[#E9E9E9] rounded-2xl">
        <div className="relative z-10">
          <p className=" text-[#BDADC9] text-sm font-medium text-muted-foreground group-hover:text-white transition-colors duration-500">
            {title}
          </p>

          <div className="text-3xl font-500 font-[#10001D] tracking-tight my-2 leading-none">
            {value}
          </div>

          {/* <div className="flex items-center text-xs font-semibold">
            {id === 1 && (
              <ArrowUp
                className="mr-1 h-4 w-4 text-green-500 group-hover:text-[#00FF00] transition-colors duration-500"
                fill="currentColor"
              />
            )}
            <span className="text-green-600 group-hover:text-[#00FF00] transition-colors duration-500">
              {id === 1 && change}
            </span>
            <span className="ml-1 font-medium text-muted-foreground group-hover:text-white/50 transition-colors duration-500">
              {id === 1 && 'More This Week'}
            </span>
          </div> */}
        </div>

        <div
          className={cn(
            'absolute right-4 top-[20px] transition-all duration-700 pointer-events-none z-0',

            'text-[#9275C9] group-hover:text-white group-hover:opacity-20 group-hover:rotate-12'
          )}
        >
          <img
            src={image as string}
            alt=""
            className={`w-[81.61px] h-[58.46px] object-contain  transition-all text-[#9275C9] group-hover:text-white ${id === 1 && 'opacity-20'}`}
          />
        </div>
      </CardContent>
    </Card>
  );
}

export default MetricCard;
